import { Check } from "lucide-react";

const steps = [
  { key: "planning", label: "Planning" },
  { key: "venue_voting", label: "Voting" },
  { key: "committed", label: "Committed" },
  { key: "booked", label: "Booked" },
  { key: "completed", label: "Settled" },
];

const KrewProgressTracker = ({ status }: { status: string }) => {
  const currentIdx = steps.findIndex(s => s.key === status);
  const activeIdx = currentIdx === -1 ? 0 : currentIdx;

  return (
    <div className="flex items-center gap-1 overflow-x-auto py-2">
      {steps.map((step, i) => {
        const done = i < activeIdx;
        const active = i === activeIdx;
        return (
          <div key={step.key} className="flex items-center">
            <div className="flex flex-col items-center">
              <div className={`flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold transition-all ${
                done ? "bg-primary text-primary-foreground" :
                active ? "bg-primary/20 text-primary border-2 border-primary" :
                "bg-muted text-muted-foreground"
              }`}>
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <span className={`mt-1 text-[10px] font-medium whitespace-nowrap ${
                done || active ? "text-foreground" : "text-muted-foreground"
              }`}>{step.label}</span>
            </div>
            {i < steps.length - 1 && (
              <div className={`mx-1 h-0.5 w-6 sm:w-10 ${done ? "bg-primary" : "bg-muted"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KrewProgressTracker;
